import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpelComponent } from './simple-icons-opel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpelComponent ],
    exports:      [ SimpleIconsOpelComponent ],
    bootstrap:    []
})
export class SimpleIconsOpelModule {}
